/**
 * Best-effort conversion of markdown to a single-line, plain-text preview.
 *
 * This is NOT a markdown renderer — it strips the syntax/entities that would
 * otherwise surface as literal noise (`*`, `#`, `&nbsp;`, list bullets, …) in a
 * compact inline preview (e.g. a one-line label). Render real content with a
 * proper renderer; use this only for short previews where rich formatting can't
 * fit on one line.
 */
export const markdownToPreviewText = (markdown: string): string => {
  // Decode HTML entities (e.g. `&nbsp;`) and drop any stray tags via the DOM —
  // mirrors the WYSIWYG-emptiness check and avoids regex-on-HTML pitfalls.
  const decoded = new DOMParser().parseFromString(markdown, "text/html").body.textContent ?? "";

  return decoded
    .replace(/^\s{0,3}(?:[-+*]|\d+\.)\s+/gm, "") // leading list markers
    .replace(/^\s{0,3}#{1,6}\s+/gm, "") // heading markers
    .replace(/(\*\*|__|~~|\*|_|`)/g, "") // emphasis / inline-code markers
    .replace(/\s+/g, " ") // collapse newlines/whitespace to a single line
    .trim();
};
